import { render, staticRenderFns } from "./Step_4.vue?vue&type=template&id=0b8ab7bc&scoped=true&"
import script from "./Step_4.vue?vue&type=script&lang=ts&"
export * from "./Step_4.vue?vue&type=script&lang=ts&"
import style0 from "./Step_4.vue?vue&type=style&index=0&id=0b8ab7bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b8ab7bc",
  null
  
)

export default component.exports